import './HowItWorks.css';

const steps = [
  {
    num: '01',
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <rect x="5" y="4" width="22" height="24" rx="5" fill="#EEF2FD"/>
        <path d="M10 12h12M10 16h8M10 20h10" stroke="#5784E6" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="26" cy="8" r="5" fill="#FFB400"/>
        <path d="M24.5 8l1 1 2-2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Notunu Yükle',
    desc: 'Ders notunu sisteme yükle ve bölüm, dönem, ders gibi bilgileri seçerek doğru kategoriye ekle.',
  },
  {
    num: '02',
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="11" fill="#EEF2FD"/>
        <path d="M11 16l3 3 7-7" stroke="#5784E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="26" cy="8" r="5" fill="#FFB400"/>
        <circle cx="26" cy="8" r="2" fill="white"/>
      </svg>
    ),
    title: 'Ön Kontrolden Geçsin',
    desc: 'Yüklenen not, kalite ve içerik uygunluğu açısından AI destekli ön kontrolden geçirilir.',
  },
  {
    num: '03',
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <rect x="4" y="10" width="10" height="14" rx="4" fill="#EEF2FD"/>
        <rect x="18" y="10" width="10" height="14" rx="4" fill="#EEF2FD"/>
        <path d="M14 17h4" stroke="#5784E6" strokeWidth="2" strokeLinecap="round"/>
        <path d="M15.5 15l-2 2 2 2" stroke="#5784E6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.5 15l2 2-2 2" stroke="#5784E6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="26" cy="8" r="5" fill="#FFB400"/>
        <path d="M23.5 8h5M26 5.5v5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    title: 'İhtiyaçlarla Eşleşsin',
    desc: 'Yüklediğin not, başka öğrencilerin ihtiyaçlarına uygun arama ilanlarıyla eşleşebilir.',
  },
  {
    num: '04',
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="11" fill="#EEF2FD"/>
        <path d="M10 16l4 4 8-8" stroke="#5784E6" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="26" cy="8" r="5" fill="#FFB400"/>
        <path d="M24 8h4M26 6v4" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Eşleşme Tamamlansın',
    desc: 'İstek kabul edildiğinde eşleşme tamamlanır ve ilgili nota erişim sağlayabilirsin.',
  },
];

export default function HowItWorks() {
  return (
    <section className="how" id="how-it-works">
      <div className="container">
        <div className="how__tag">Nasıl Çalışır?</div>
        <h2 className="section-title">Not paylaş, not kazan</h2>
        <p className="section-subtitle">
          NoteSwapp'te öğrenciler yalnızca not indirmez; kendi notlarını paylaşarak başka öğrencilerin notlarına adil şekilde erişir. Bir kullanıcı not yüklediğinde, sistem notun bilgilerini ve uygunluğunu kontrol eder. Daha sonra kullanıcı, erişmek istediği not için kendi paylaştığı bir notla değişim isteği oluşturabilir. İstek kabul edildiğinde eşleşme tamamlanır.
        </p>

        <div className="how__grid">
          {steps.map((step, i) => (
            <div className="how__card" key={i}>
              <div className="how__card-top">
                <div className="how__icon-wrap">{step.icon}</div>
                <span className="how__num">{step.num}</span>
              </div>
              <h3 className="how__card-title">{step.title}</h3>
              <p className="how__card-desc">{step.desc}</p>
              {i < steps.length - 1 && (
                <div className="how__arrow">→</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
